import useSWR from "swr";
import * as aiccLanguageAPI from "services/aiccLanguage";
import { AICC_SWR_CONFIG } from "./swrConfig";

/**
 * The global language library minus anything already under management (AC-1).
 * Soft-deleted languages reappear here, which is what makes them re-addable.
 *
 * `shouldFetch` keeps the request off the wire until the Add Language modal opens.
 */
export function useAiccAvailableLanguages(shouldFetch: boolean) {
  const { data, error, isLoading, mutate } = useSWR(
    shouldFetch ? ["aicc/available-languages"] : null,
    () => aiccLanguageAPI.fetchAiccAvailableLanguages(),
    AICC_SWR_CONFIG
  );

  return {
    availableLanguages: data ?? [],
    isLoading,
    isError: !!error,
    mutate,
  };
}
